<div class="row g-0">
  @for (column of productColumns; track $index) {
    <div class="col-lg-6 col-12 products-column">
      @for (productType of column; track productType.id) {
        @switch (productType.structureType) {
          @case (STRUCTURE_TYPES.PIECES) {
            <single-piece-type [productType]="productType"
                               [cartLines]="cartLines"
                               [showImage]="showImages"
                               (onSaveToCart)="saveLineToCart.emit($event)"
                               (onRemoveCartLine)="removeLineFromCart.emit($event)"
                               (showModal)="showModal.emit($event)"
                               (showCart)="showCart.emit()">
            </single-piece-type>
          }

          @case (STRUCTURE_TYPES.PIECES_GROUP) {
            <pieces-group-type [productType]="productType"
                               [cartLines]="cartLines"
                               [showImage]="showImages"
                               (onSaveToCart)="saveLineToCart.emit($event)"
                               (onRemoveCartLine)="removeVariantFromCart.emit($event)"
                               (showModal)="showModal.emit($event)"
                               (showCart)="showCart.emit()">
            </pieces-group-type>
          }

          @case (STRUCTURE_TYPES.COMPLEX) {
            <complex-type [productType]="productType"
                          [cartLines]="cartLines"
                          [showImage]="showImages"
                          (onSaveToCart)="saveLineToCart.emit($event)"
                          (onRemoveCartLine)="removeLineFromCart.emit($event)"
                          (showModal)="showModal.emit($event)"
                          (showCart)="showCart.emit()">
            </complex-type>
          }

          @case (STRUCTURE_TYPES.CATERING_MENU) {
            <catering-menu-type [productType]="productType"
                                [cartLines]="cartLines"
                                [showImage]="showImages"
                                (showModal)="showModal.emit($event)"
                                (showCart)="showCart.emit()">
            </catering-menu-type>
          }

          @case (STRUCTURE_TYPES.REQUEST_FORM) {
            <request-form-type [productType]="productType"
                               [showImage]="showImages"
                               (showModal)="showModal.emit($event)">
            </request-form-type>
          }
        }
      }
    </div>
  }
</div>

<ng-content></ng-content>
